// 1... importing React specific APIs.
import { Fragment } from "react";

interface TableProps {
  headers: string[];
  children: React.ReactNode;
  className?: string;
}

interface TableHeaderProps {
  headers: string[];
  className?: string;
}

export default function Table ({ headers, children, className="" }: TableProps) {
  return (
    <Fragment>
      <table className='w-full text-left text-sm rtl:text-right'>
        <TableHeader className={className} headers={headers} />
        {children}
      </table>
    </Fragment>
  );
}

const TableHeader = ({ headers, className }: TableHeaderProps) => {
  return (
    <thead className={`bg-surface-primary text-xs uppercase text-primary ${className}`}>
      <tr className='text-center'>
        {headers?.map((header) => (
          <th className='p-6' key={header} scope='col'>
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );
};
